import { createSelector } from '@reduxjs/toolkit';

export const getPartners = ()=> {
    return createSelector(
        (state) => state.partners,
        (state) => state
    )
}